import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'

import useForceStopModal from './useForceStopModal'
import { ModalActions, ModalText } from '../styled-components'

const ForceStopModal = () => {
  const { isOpen, isSubmitting, title, text, confirmLabel, setIsOpen, confirm } = useForceStopModal()

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={setIsOpen}
      title={title}
      sections={
        <>
          <ModalText>{text}</ModalText>
          <ModalActions>
            {/* @ts-expect-error SDButton is a JS component */}
            <SDButton id='break-force-stop-confirm-btn' disabled={isSubmitting} onClick={confirm}>
              {confirmLabel}
            </SDButton>
          </ModalActions>
        </>
      }
    />
  )
}

export default ForceStopModal
